import { Navigate } from "react-router-dom"

import Cookies from "js-cookie"

const AdminProtectedRoute = ({ children }) => {

  const data = JSON.parse(
    Cookies.get("logincrd") || "{}"
  )

  const token = data?.token

  const user = data?.user

  // NOT LOGIN

  if (!token) {

    return <Navigate to="/login" />
  }

  // NOT ADMIN

  if (user?.role !== "admin") {

    return <Navigate to="/" />
  }

  return children
}

export default AdminProtectedRoute